var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"item-preview"},[_c('button',{staticClass:"btn small",on:{"click":function($event){return _vm.$emit('remove', _vm.item._id)}}},[_vm._v("X")]),_c('router-link',{attrs:{"to":{name: _vm.itemDetailesPageName, params: {id: _vm.item._id}}}},[_c('pre',[_vm._v(_vm._s(_vm.item))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }